import { Inject, Injectable, Injector } from '@angular/core';

import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.FootPrintPortalManager = this.injector.get(FootPrintPortalManager_FlowService);
  }

    public FootPrintPortalManager: FootPrintPortalManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
